import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FooterNavButtons from './FooterNavButtons';
import FooterNavRow from './FooterNavRow';

import styles from './footer.scss';
import footerSelector from '../../selectors/footer/FooterSelector';

const Footer = (props) => {
    const {
        footerTagName,
        footerAttributes,
        isLargeTest,
        shouldRenderNavRow,
        showFooterNavButtons,
    } = props;

    const classList = [styles.footer];
    if (isLargeTest) {
        classList.push(styles.scrollableFooter);
    }

    const FooterTag = footerTagName || 'footer';
    return (
        <FooterTag {...footerAttributes} className={classList.join(' ')}>
            { showFooterNavButtons && <FooterNavButtons {...props} />}
            { shouldRenderNavRow && <FooterNavRow {...props} /> }
        </FooterTag>
    );
};

Footer.propTypes = {
    footerTagName: PropTypes.string,
    footerAttributes: PropTypes.object,
    isLargeTest: PropTypes.bool.isRequired,
    shouldRenderNavRow: PropTypes.bool.isRequired,
    showFooterNavButtons: PropTypes.bool,
};

const mapStateToProps = state => footerSelector.selectProps(state);
export default connect(mapStateToProps)(Footer);
